export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/ee9346a7a9322dc42520ebdf49402b79.svg";